<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号/车牌号/车架号" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onResetAllClick">重置所有不定位设备</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'unlocatedanalysiss',
  components: {
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      stateFilter: null,
      offlineFilter: null,

      // 离线处理
      processOfflineModal: false,
      processOfflineId: null,

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '终端登记车牌号',
          resizable: true,
          key: 'registrationNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '终端登记车牌类型',
          resizable: true,
          key: 'vehicleType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '终端登记发动机号',
          resizable: true,
          key: 'engineNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '终端累计里程',
          resizable: true,
          key: 'lastMileage',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          render: (h, params) => {
            return h('label', params.row.lastMileage / 10)
          }
        },
        {
          title: '终端登记车架号',
          resizable: true,
          key: 'vin',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180
        },
        {
          title: '周期内统计不定位次数',
          resizable: true,
          sortable: 'custom',
          key: 'count',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '处理状态',
          resizable: true,
          key: 'state',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '未处理', value: 1 },
            { label: '继续跟进', value: 2 },
            { label: '已处理', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.state
            if (state === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '未处理')
              ])
            } else if (state === 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '继续跟进')
              ])
            } else if (state === 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '已处理')
              ])
            }
          }
        },
        {
          title: '分析时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'analyzeDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.analyzeDatetime) {
              let d = new Date(params.row.analyzeDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          minWidth: 90,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认重置终端',
                      content: '<p>注意：重置用时约5分钟，可能存在参数设置不成功，请查询jt808数据和里程确认</p>',
                      onOk: () => {
                        store.dispatch('UnlocatedAnalysisServ_ResetOne', {
                          params: { id: params.row.id },
                          urlparams: null
                        }).then(() => {
                          this.$Message.success('开始重置终端')
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {
                      }
                    })
                  }
                }
              }, '重置终端')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'ClientInfoServ_GetPage',
      'UnlocatedAnalysisServ_ResetOne'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onResetAllClick () {
      store.dispatch('UnlocatedAnalysisServ_ResetAll', {
        params: null,
        urlparams: null
      }).then(() => {
        this.$Message.success('开始重置设备')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    filterChange () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null
      let qo2 = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      }
      if (this.offlineFilter) {
        qo2 = this.offlineFilter
      }

      store.dispatch('UnlocatedAnalysisServ_GetPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          qo2: qo2,
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_UnlocatedAnalysis_GetPageResult) {
        return store.getters.get_UnlocatedAnalysis_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_UnlocatedAnalysis_GetPageResult) {
        return store.getters.get_UnlocatedAnalysis_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_UnlocatedAnalysis_GetPageResult) {
        return store.getters.get_UnlocatedAnalysis_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
